@if (!has404Error && !pageData) {
  <div class="loading-screen">
    <mat-spinner [mode]="'indeterminate'" class="bright-green"></mat-spinner>
  </div>
}

@if (has404Error) {
  <app-error-404></app-error-404>
}

@if (pageData) {

  @switch (selectedView) {

    @case (E_VIEW_TYPE.NewsList) {
      <app-news
        [pageData]="pageData">
      </app-news>
    }
    @case (E_VIEW_TYPE.NewsDetail) {
      <app-news-details
        [pageData]="pageData">
      </app-news-details>
    }
    @case (E_VIEW_TYPE.Home) {
      <app-home
        [pageData]="pageData">
      </app-home>
    }
    @case (E_VIEW_TYPE.PublicationDetail) {
      <app-publication-details
        [pageData]="pageData">
      </app-publication-details>
    }
    @case (E_VIEW_TYPE.PublicationList) {
      <app-publication-list
        [pageData]="pageData">
      </app-publication-list>
    }
    @case (E_VIEW_TYPE.MeetingDetail) {
      <app-content-page
        [showTags]="false"
        [pageData]="pageData">
      </app-content-page>
    }
    @case (E_VIEW_TYPE.MeetingList) {
      <app-meeting-list
        [pageData]="pageData">
      </app-meeting-list>
    }
    @case (E_VIEW_TYPE.StandardsList) {
      <app-content-page
        [showTags]="false"
        [pageData]="pageData">
      </app-content-page>
    }
    @case (E_VIEW_TYPE.StandardsDetail) {
      <app-content-page
        [showTags]="false"
        [pageData]="pageData">
      </app-content-page>
    }
    @case (E_VIEW_TYPE.DiscussionDetail) {
      <app-content-page
        [customDateField]="'recordedDate'"
        [pageData]="pageData">
      </app-content-page>
    }
    @case (E_VIEW_TYPE.JurisdictionList) {
      <app-jurisdiction-list
        [pageData]="pageData">
      </app-jurisdiction-list>
    }
    @case (E_VIEW_TYPE.JurisdictionDetail) {
      <app-jurisdiction-details
        [pageData]="pageData">
      </app-jurisdiction-details>
    }
    @case (E_VIEW_TYPE.ResourceList) {
      <app-resources-list
        [pageData]="pageData">
      </app-resources-list>
    }
    @case (E_VIEW_TYPE.ResourceDetail) {
      <app-resources-details
        [pageData]="pageData">
      </app-resources-details>
    }
    @case (E_VIEW_TYPE.ImportantDatesDetail) {
      <app-important-dates-detail [pageData]="pageData">
      </app-important-dates-detail>
    }
    @default {
      <app-content-page
        [showTags]="false"
        [pageData]="pageData">
      </app-content-page>
    }
  }

}
